import React from 'react'
import styled from 'styled-components'

const NavComparativeReports = ({activePage, useTranslate, handleChange}) => {

  const handleClick = (section) => {
    handleChange(section)
  }

  return (
    <NavWrapper className="comparative-reports-nav">
      <NavLink
        onClick={() => handleClick("overall")}
        className={`${activePage === "overall" ? "active" : ""}`}
      >
        {useTranslate("comparative_reports.cr_nav_overall")}
      </NavLink>
      <NavLink
        onClick={() => handleClick("themes")}
        className={`${activePage === "themes" ? "active" : ""}`}
      >
        {useTranslate("comparative_reports.cr_nav_themes")}
      </NavLink>
      <NavLink
        onClick={() => handleClick("drivers")}
        className={`${activePage === "drivers" ? "active" : ""}`}
      >
        {useTranslate("comparative_reports.cr_nav_drivers")}
      </NavLink>
      <NavLink
        onClick={() => handleClick("statements")}
        className={`${activePage === "statements" ? "active" : ""}`}
      >
        {useTranslate("comparative_reports.cr_nav_statements")}
      </NavLink>
    </NavWrapper>
  )
}

export default NavComparativeReports;

const NavWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const NavLink = styled.button`
  display: block;
  border: none;
  appearance: none;
  background-color: #fff;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 10px;
  margin-right: 7px;
  margin-bottom: 7px;
  cursor: pointer;
  transition: all .3s ease-in-out;
  outline: none;
  
  &:hover {
    color: #F58220;
  }
  
  &:hover, 
  &:focus,
  &:active {
    outline: none;
  }
  
  &.active {
    background-color: #F58220;
    color: #fff;
  }
`;


// WEBPACK FOOTER //
// ./src/components/navigation/nav-comparative-reports.js